import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";

const DEFAULT_LANGUAGE = "fi"

i18next
  .use(initReactI18next)
   //TODO npm install i18next-browser-languagedetector? do we need this?
  // .use(LanguageDetector)
  // Load localizations from files
  .use(HttpApi) 
  .init({
    // Set Default language
    lng: DEFAULT_LANGUAGE,
    // Set which language to use as fallback if translation is not found
    fallbackLng: DEFAULT_LANGUAGE,
    // Allowed languages
    supportedLngs: ["fi", "se"],
    interpolation: {
      escapeValue: false,
    }
  });
  
export default i18next;
